var _path, _path2, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeadsPageBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 780,
    viewBox: "0 0 1440 780",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2208_1028)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1440 0H0V36V538V780C0 780 420.528 656.54 708.074 653.888C1004.59 651.154 1440 780 1440 780V538V36V0Z",
    fill: "#1C2634"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2208_1028",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 780
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1440 0H0V36V538V780C0 780 420.528 656.54 708.074 653.888C1004.59 651.154 1440 780 1440 780V538V36V0Z",
    fill: "#1C2634"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2208_1028)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "exclusion"
    },
    opacity: 0.4
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1022,
    fill: "url(#pattern0)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 0.124583,
    height: 1.75538
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2208_1028",
    transform: "scale(0.00249167 0.00351076)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2208_1028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 780,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2208_1028",
    width: 50,
    height: 500,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAH0CAMAAABIJ46eAAAAZlBMVEVMTEyioqKqqqqkpKSpqammpqaoqKioqKipqamkpKSqqqqrq6uenp6srKyZmZmsrKySkpKtra2Ghoatra14eHhtbW2urq6tra2UlJSsrKyampqfn5+mpqahoaGrq6usrKyKioqurq6h195FAAAAInRSTlMKNFQ7TT9GSVA4V14qYiNsHHMVehEOd3AfZSYtQjFbaRh+yNRJHgAAAWJJREFUeAHsmVkSgjAUBAk7giwadgW8/yU9w5gqnJow//3RX0nXC/45gyNhQLoIR2JWlwRHUlaXzF2fZjmOFKwuNxwxrC4ljlSsLnccqVldGhxpWV06HHmwujxxxAZnrHd3oZnFkYHVpcWRkdVlwpGZ1WVxf19otp7wh8F3hVUiFFYvd4Rmsd9hZYTC6i0UIwuryywUVqPfYWWFwqpnjRHasPohqzuhsGpYXWqhsKpwpBSKEdqwKnAkFwqrjNUl9TusIlaXUCisNhxZ5cOKYDuOTEJhdbC6DEJh9ZG/8hDs8PvKs1OKXFee7duuHcgAAAAADPK3TiSM7708+Vw+l8/lc/lcPpfP5XP5XD6Xzw2rfC6fy+fyuXzu5cnn8rl8Lp/L5/K5fC6fy+fyuXwun8vn8rl8Lp97efK5fC6fe3nyuXwun8vn8rl8Lp/L5/K5fC6fG1b5XD6Xz+Vz+dzLk8/lcwAUdw8ElkOCwgAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsPageBg);
export default __webpack_public_path__ + "static/media/leads-page-bg.ed0e177ce2d1574001dc283f8027e629.svg";
export { ForwardRef as ReactComponent };